var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgB = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 125 58"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M22.862 1.017 1.834 19.807A4 4 0 0 0 .5 22.79V40.5a4 4 0 0 0 4 4h7.018C13.016 39.58 17.59 36 23 36s9.984 3.58 11.482 8.5h55.036C91.016 39.58 95.59 36 101 36s9.984 3.58 11.482 8.5h7.589a4 4 0 0 0 3.979-4.406l-1.683-16.5a4 4 0 0 0-3.98-3.594H96.386a4 4 0 0 1-3.086-1.454L79.2 1.454A4 4 0 0 0 76.114 0H25.527a4 4 0 0 0-2.666 1.017m3.26 4.862A3 3 0 0 1 28.241 5H41a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H17.243c-2.673 0-4.012-3.231-2.122-5.121zM74.517 5A3 3 0 0 1 76.9 6.178l8.411 11c1.51 1.974.102 4.822-2.383 4.822H52a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M23 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m0-4a6 6 0 1 0 0-12 6 6 0 0 0 0 12M101 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m0-4a6 6 0 1 0 0-12 6 6 0 0 0 0 12",
  clipRule: "evenodd"
})));
export default SvgB;